import { useState } from 'react';
import { LinkButton } from '../../../components/linkButton.tsx';
import { ModalDialog } from '../../../components/modalDialog.tsx';
import { trpc } from '../../../utils/trpc/trpc.ts';
import { ManualTasksTable } from './manualTasksTable.tsx';


interface Props {
    onClose: () => void;
}

export function TasksLogDialog({
    onClose,
}: Props) {

    const [numTasksToLoad, setNumTasksToLoad] = useState(10);

    const { data: tasks } = trpc.tasks.getManualTasks.useQuery({
        isClosed: true,
        sort: { closedAt: -1 },
        limit: numTasksToLoad
    }, {
        placeholderData: (prev) => prev,
    });


    return (
        <ModalDialog
            frameStyle={{ width: '1200px' }}
            isOpen={true}
            onCancel={onClose}
        >
            <div className='flex--vert'>
                <ManualTasksTable
                    tasks={tasks ?? []}
                    showCreatedAt={true}
                    showActivatedAt={true}
                    showClosedAt={true}
                    showCreatedBy={true}
                    showClosedStatus={true}
                    showClosedBy={true}
                />
                <LinkButton
                    onClick={() => setNumTasksToLoad((prev) => prev + 10)}
                    disabled={!tasks || tasks.length !== numTasksToLoad}
                    content='Load more'
                />
            </div>

            <div className='dialog--button-bar'>
                <button onClick={onClose}>Close</button>
            </div>
        </ModalDialog>
    )
}
